import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import ServiceDetail from "@/pages/ServiceDetail";
import SellerProfile from "@/pages/SellerProfile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import HowItWorks from "@/pages/HowItWorks";
import BecomeSeller from "@/pages/BecomeSeller";
import Policies from "@/pages/Policies";
import Messages from "@/pages/Messages";
import VerifyEmail from "@/pages/VerifyEmail";
import PendingVerification from "@/pages/PendingVerification";
import BuyerDashboard from "@/pages/dashboard/BuyerDashboard";
import SellerDashboard from "@/pages/dashboard/SellerDashboard";
import AdminDashboard from "@/pages/dashboard/AdminDashboard";

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-gray-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  // Block protected routes for unverified users (admins exempt).
  if (user.role !== "admin" && user.email_verified === false) {
    return <Navigate to="/pending-verification" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/browse" element={<Browse />} />
              <Route path="/service/:id" element={<ServiceDetail />} />
              <Route path="/seller/:user_id" element={<SellerProfile />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/become-a-seller" element={<BecomeSeller />} />
              <Route path="/policies" element={<Policies />} />
              <Route path="/terms" element={<Policies />} />
              <Route path="/refund-policy" element={<Policies />} />
              <Route path="/messages" element={<Protected><Messages /></Protected>} />
              <Route path="/dashboard/buyer/*" element={<Protected roles={["buyer", "admin"]}><BuyerDashboard /></Protected>} />
              <Route path="/dashboard/seller/*" element={<Protected roles={["seller", "admin"]}><SellerDashboard /></Protected>} />
              <Route path="/dashboard/admin/*" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/pending-verification" element={<PendingVerification />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
